import { SystemService } from './../service/system.service';
import { OnDestroy, NgZone } from '@angular/core';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, HostListener} from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute, NavigationCancel } from '@angular/router';

import { BLocalStorageService } from '../service/bLocalStorage.service';
import { BTokenService } from '../service/bToken.service';
import { dashboardService } from '../services/dashboard/dashboard.service';
import { BLoginService } from '../service/bLogin.service';
import { PubSubService } from '../service/pubSub.service';
import { Observable } from 'rxjs/Rx';
import { BLogoutService } from '../service/bLogout.service';
import { utilityService } from '../services/utility/utility.service';
// import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
/**
 * Model import Example :
 * import { HERO } from '../models/hero.model.ts';
 */

@Component({
  selector: 'bh-layoutpage',
  templateUrl: './layoutpage.template.html'
})

export class layoutpageComponent implements OnInit, OnDestroy{

  showHomeIcon = false;
  bTokenService;
  bLocalStorageService;
  actionButtons;
  tabListner;
  timer;
  timerSubscription;
  systemS;


  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private locationStrategy: LocationStrategy, private mulNotificationService: dashboardService,
    private bLoginService: BLoginService, private pubsub: PubSubService, private logoutService: BLogoutService,
    private ngZone: NgZone, public utilityS: utilityService ) {
    this.bTokenService = new BTokenService();
   this.bLocalStorageService = new BLocalStorageService()
    this.systemS = new SystemService();
    this.router.events.subscribe(event => {
      this.utilityS.applyConditionalCss();
      if ((event instanceof NavigationEnd || event instanceof NavigationCancel) &&
        event.url && (event.url.substr(0, event.url.indexOf('?')) === '/bhive' ||event.url === '/bhive' ||
          event.url === '/login' || event.url === '/')) {
        this.showHomeIcon = false;
      } else {
        this.showHomeIcon = true;
      }
    });
  }
  ngOnInit() {

    this.startTimerEmitter();
    this.tabListner = this.pubsub.$sub('tabListner', (eventObject) => {
      this.actionButtons = [];
      if (eventObject && eventObject.length > 0) {
        this.actionButtons = eventObject;
      }
    });
    if (this.bLocalStorageService.getValue('accessToken')) {
      this.bTokenService.updateSessionStorage();
    }
    if (this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data.dashboard) {
      this.mulNotificationService.dashboardObject = this.activatedRoute.snapshot.data;
    }
   
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.systemS.deviceType !== 'browser') {
      if (navigator['app'] && (this.router.url.substr(0, this.router.url.indexOf('?')) === '/bhive' || this.router.url === '/bhive')) {
        navigator['app'].exitApp();
      }
    }
  }

  navToHome() {
    this.ngZone.run(() => {
      this.router.navigate(['/bhive']);
    })
  }

  logout() {
    if (this.logoutService.logout()) {
      this.ngZone.run(() => {
        this.router.navigate(['/login']);
      })
    }
  }

  broadcastActionEvent(event, eventObject) {
    this.pubsub.$pub(event, eventObject);
  }

  startTimerEmitter() {
    this.timer = Observable.interval(1000 * 60);

    this.timerSubscription = this.timer.subscribe(x => {
      this.pubsub.$pub('getData');
    })
  }

  ngOnDestroy() {
    this.timerSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/layoutpageComponent/layoutpage.component.ts